// @flow
import * as React from "react";
import Icons from "ui/Icons";

import Dropdown from "./Dropdown";

type Props = {
  /** Whether the menu is disabled */
  disabled?: boolean,
  /** The position of the menu */
  position?: any,
  /** The options for the menu */
  options: Array<{ label: string, onClick: () => void, disabled?: boolean }>,
};

/** A menu that opens when a button is clicked */
function ChevronDownMenu({ disabled, position, options }: Props): React.Node {
  return (
    <Dropdown
      items={options.map((option, index) => ({
        key: `option-${index}-${option.label}`,
        label: (
          <button
            className="block w-full text-center px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none transition duration-150 ease-in-out"
            disabled={option?.disabled}
            onClick={option.onClick}
            type="button"
          >
            {option.label}
          </button>
        ),
      }))}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <button
        className={`flex m-auto items-center ${
          disabled
            ? "text-gray-200"
            : "text-gray-400 hover:text-gray-600 focus:outline-none focus:text-gray-600"
        }`}
      >
        <Icons.ChevronDown inheritColor size={4} />
      </button>
    </Dropdown>
  );
}

export default ChevronDownMenu;
